export const PHONE_DISPLAY = "(91) 98174-0728";
export const PHONE_TEL = "tel:+5591981740728";
export const EMAIL = "brasiltransportespa01@gmail.com";
export const INSTAGRAM_HANDLE = "@brasiltransportes.pa";
export const INSTAGRAM_URL = "https://www.instagram.com/brasiltransportes.pa";

export const DEFAULT_WA_MSG =
  "Olá! Preciso de atendimento para meu veículo. Minha localização é ______ e o veículo é ______.";

export const waLink = (msg = DEFAULT_WA_MSG) =>
  `https://wa.me/5591981740728?text=${encodeURIComponent(msg)}`;
